/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AdditionalInformationInner } from './additionalInformationInner';
import { PriceCalculation } from './priceCalculation';

/**
 * This contains a list of various price calculations.
 */
export interface MultiQuoteResponse {
  /**
   * Set of regular available prices. In case of motor products, there may be entries for every available package (Basic, Classic, Premium, ...)    This is a set of prices, combined with a detailed description how the price caclulation was done.   NOTE: The *salesProduct* property has an identical structure compared with the input data,  but it contains only prices and few relevant properties.
   */
  regularPrices?: Array<PriceCalculation>;
  /**
   * Reference prices are intended for frontend purposes only. They are more expensive compared to the regular prices.   Usually the input data for the price caclulation are somehow modified,  in order to calculate the reference price.   (german: Streichpreise, Referenzpreis)    This is a set of prices, combined with a detailed description how the price caclulation was done.   NOTE: The *salesProduct* property has an identical structure compared with the input data,  but it contains only prices and few relevant properties.
   */
  referencePrices?: Array<PriceCalculation>;
  /**
   * Set of additional price calculations. These calculations are agent specific.  This is a set of prices, combined with a detailed description how the price caclulation was done.   NOTE: The *salesProduct* property has an identical structure compared with the input data,  but it contains only prices and few relevant properties.
   */
  additionalPrices?: Array<PriceCalculation>;
  /**
   * Additional information concerning the response.
   */
  additionalInformation?: Array<AdditionalInformationInner>;
}
